export const getLast4Digits = (phoneNumber: string): string => phoneNumber.slice(-4);

export const checkNumericValue = (value: string, digits: number): string => {
  if (value.length > digits) {
    return value.slice(0, digits);
  }

  return value.replace(/\D/g, '');
};

export const getHyphenatedSSNValue = (value: string): string => {
  let valueNumeric = value.replace(/\D/g, '');
  let newVal = '';
  let ssn = '';
  if (valueNumeric.length > 4) {
    ssn = valueNumeric;
  }
  if (valueNumeric.length > 3 && valueNumeric.length < 6) {
    newVal += `${valueNumeric.substr(0, 3)}-`;
    valueNumeric = valueNumeric.substr(3);
  }
  if (valueNumeric.length > 5) {
    newVal += `${valueNumeric.substr(0, 3)}-`;
    newVal += `${valueNumeric.substr(3, 2)}-`;
    valueNumeric = valueNumeric.substr(5);
  }
  newVal += valueNumeric;
  ssn = newVal;

  return ssn;
};
